import { render } from "./Statusbar.vue?vue&type=template&id=70401bba&scoped=true"
import script from "./Statusbar.vue?vue&type=script&lang=js"
export * from "./Statusbar.vue?vue&type=script&lang=js"

import "./Statusbar.vue?vue&type=style&index=0&id=70401bba&scoped=true&lang=css"

import exportComponent from "C:\\_Development\\JavaScript\\Vue\\flightlog\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70401bba"]])

export default __exports__